export default __webpack_public_path__ + "static/Consultant-967f3bf9912046d9792839c2e667cf7089e5eeda21ca5f81b1e038a48151d44c.png";